const getFooterData = () => ({
  copyrightText: `&copy; Viking Cruises, ${new Date().getFullYear()}. All Rights Reserved.`,
  handleModalOpen: () => null,
  id: 'c0be92a6-0d1a-438a-869c-29527758d800',
});

export default getFooterData;
